export const GET_COACH_REFERRALS_REQUEST = "GET_COACH_REFERRALS_REQUEST"
export const GET_COACH_REFERRALS_SUCCESS = "GET_COACH_REFERRALS_SUCCESS"
export const GET_COACH_REFERRALS_ERROR = "GET_COACH_REFERRALS_ERROR"
export const GET_COACH_REFERRAL_REQUEST = "GET_COACH_REFERRAL_REQUEST"
export const GET_COACH_REFERRAL_SUCCESS = "GET_COACH_REFERRAL_SUCCESS"
export const GET_COACH_REFERRAL_ERROR = "GET_COACH_REFERRAL_ERROR"
export const CREATE_COACH_REFERRAL_REQUEST = "CREATE_COACH_REFERRAL_REQUEST"
export const CREATE_COACH_REFERRAL_SUCCESS = "CREATE_COACH_REFERRAL_SUCCESS"
export const CREATE_COACH_REFERRAL_ERROR = "CREATE_COACH_REFERRAL_ERROR"
export const EDIT_COACH_REFERRAL_REQUEST = "EDIT_COACH_REFERRAL_REQUEST"
export const EDIT_COACH_REFERRAL_SUCCESS = "EDIT_COACH_REFERRAL_SUCCESS"
export const EDIT_COACH_REFERRAL_ERROR = "EDIT_COACH_REFERRAL_ERROR"
export const DELETE_COACH_REFERRAL_REQUEST = "DELETE_COACH_REFERRAL_REQUEST"
export const DELETE_COACH_REFERRAL_SUCCESS = "DELETE_COACH_REFERRAL_SUCCESS"
export const DELETE_COACH_REFERRAL_ERROR = "DELETE_COACH_REFERRAL_ERROR"
export const CLEAR_COACH_REFERRAL_STATE = "CLEAR_COACH_REFERRAL_STATE"